import { roomImages } from "./roomImages";

export const roomTypes = [
  {
    id: 1,
    name: "Couple Room (AC)",
    price: 2000,
    description: "A comfortable air-conditioned room with a queen-size bed, modern amenities, and a relaxing beachside atmosphere perfect for a refreshing stay.",
    maxGuests: 2,
    available: 4,
    badge: "❄️ AC",
    badgeColor: "#2a7d9c",
   images: roomImages.shrileela.coupleRoom.slice(0, 4),
    amenities: ["Queen-size Bed", "Air Conditioning", "Free WiFi", "Room Service"]
  },
  {
    id: 2,
    name: "Suite Room (AC)",
    price: 2500,
    description: "A luxurious air-conditioned suite with a king-size bed, private sea-facing balcony, premium furnishings, and exclusive amenities for an indulgent coastal escape.",
    maxGuests: 3,
    available: 2,
    badge: "👑 Suite",
    badgeColor: "#8B6914",
    images:roomImages.shrileela.suitRoom.slice(0, 4),
    amenities: ["King-size Bed", "Air Conditioning", "Sea-Facing Balcony", "Free WiFi", "Room Service", "Jacuzzi"]
  }
]
export const amenities = [
  { icon: "🏊‍♂️", name: "Swimming Pool", description: "Relax and unwind in our clean, refreshing pool" },
  { icon: "🍽️", name: "In-house Restaurant", description: "Delicious local and multi-cuisine meals available" },
  { icon: "🛎️", name: "Room Service", description: "Quick and convenient service right to your room" },
  { icon: "📶", name: "Free WiFi", description: "High-speed internet access throughout the property" },
  { icon: "🚗", name: "Ample Parking", description: "Spacious and secure parking for all guests" },
  { icon: "🐾", name: "Pet Friendly", description: "Bring your furry friends along for your stay" }
];

// shreeData.js
export const foodCategories = [
  {
    id: 1,
    type: "Vegetarian",
    title: "Veg Delights",
    description: "Farm-fresh Maharashtrian preparations cooked in pure ghee.",
    image: "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778396800/delicious-food-table_vldqbm.jpg"
  },
  {
    id: 2,
    type: "Non-Vegetarian",
    title: "Chicken & Mutton",
    description: "Fiery Malvani masalas and rich coconut-based gravies.",
    image: "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778397337/ChatGPT_Image_May_10_2026_12_44_53_PM_tadzrf.png"
  },
  {
    id: 3,
    type: "Fresh Catch",
    title: "Fish & Seafood",
    description: "Straight from the Arabian Sea — grilled, curried, or fried.",
    image: "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778398110/ChatGPT_Image_May_10_2026_12_58_07_PM_s7j0bu.png"
  },
  {
    id: 4,
    type: "House Specials",
    title: "Konkan Specials",
    description: "Chef's signature dishes celebrating the heart of Konkan coastal culture.",
    image: "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778398482/ChatGPT_Image_May_10_2026_01_04_10_PM_xrifgu.png"
  },
  {
    id: 5,
    type: "Chinese",
    title: "Indo-Chinese",
    description: "Bold wok-tossed flavours — from sizzlers and noodles to manchurian and fried rice.",
    image: "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778398681/ChatGPT_Image_May_10_2026_01_07_41_PM_xoykha.png"
  },
  {
    id: 6,
    type: "Punjabi",
    title: "Punjabi Tadka",
    description: "Hearty dhabha-style curries, tandoori classics, and buttery dal makhani.",
    image: "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778399010/ChatGPT_Image_May_10_2026_01_12_28_PM_dojk02.png"
  }
];


export const galleryImages = [
  { id: 1, url: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600&q=80", alt: "Murud Beach Shoreline", category: "Beach" },
  { id: 2, url: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=600&q=80", alt: "Resort Exterior", category: "Resort" },
  { id: 3, url: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&q=80", alt: "Couple Room Interior", category: "Rooms" },
  { id: 4, url: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=600&q=80", alt: "Sunset View", category: "Beach" },
  { id: 5, url: "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=600&q=80", alt: "Malvani Cuisine", category: "Dining" },
  { id: 6, url: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=600&q=80", alt: "Resort Pool Area", category: "Resort" },
  { id: 7, url: "https://images.unsplash.com/photo-1552733407-5d5c46c3bb3b?w=600&q=80", alt: "Beach Activities", category: "Beach" },
  { id: 8, url: "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=600&q=80", alt: "Family Room", category: "Rooms" }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya & Rohan Kulkarni",
    rating: 5,
    comment: "An absolute gem near Murud Beach! The Malvani food was outstanding and the staff was incredibly warm. Our couple room had a perfect sea view. Will definitely return!",
    date: "March 2025",
    location: "Pune"
  },
  {
    id: 2,
    name: "Vikram Desai",
    rating: 5,
    comment: "Perfect budget stay for a family trip. Clean rooms, amazing seafood, and literally 2 minutes walk to the beach. The bonfire evening was a highlight for the kids!",
    date: "February 2025",
    location: "Mumbai"
  },
  {
    id: 3,
    name: "Aisha Shaikh",
    rating: 4,
    comment: "Very affordable for what you get. The beach access is incredible, the staff goes above and beyond. Fresh fish thali was the best I've had in Konkan region!",
    date: "April 2025",
    location: "Nashik"
  }
];

export const eventSpaces = [
  {
    id: 1,
    name: "Beach Lawn",
    capacity: "50-150 guests",
    description: "Open-air beachside venue perfect for weddings, sangeet nights, and beach parties under the stars.",
    features: ["Natural beach backdrop", "Evening lighting setup", "Sound system", "Catering available"],
    image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80"
  },
  {
    id: 2,
    name: "Conference Hall",
    capacity: "20-40 guests",
    description: "Indoor space for corporate retreats, team meetings, and small gatherings with modern facilities.",
    features: ["Projector & screen", "AC", "Whiteboard", "Tea & coffee service"],
    image: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=800&q=80"
  },
  {
    id: 3,
    name: "Bonfire Area",
    capacity: "20-60 guests",
    description: "Rustic evening bonfire space for group get-togethers, birthday parties, and informal celebrations.",
    features: ["Bonfire setup", "BBQ grill", "Seating arrangement", "Music allowed"],
    image: "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&q=80"
  }
];